/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
import '../../common/time';
import '../../common/countries';
import '../../common/languages';
import '../status';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "onboard": {
            "nested": {
              "SignupToken": {
                "fields": {
                  "freeProcessingMoney": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "freeProcessingDays": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "referralUrl": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "slug": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "FreeProcessingBalance": {
                "fields": {
                  "freeProcessing": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "expiresAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ReferrerCurrentSignupTokenRequest": {
                "fields": {
                  "countryCode": {
                    "type": "squareup.common.countries.Country",
                    "id": 1,
                    "rule": "optional"
                  },
                  "languageCode": {
                    "type": "squareup.common.languages.Language",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ReferrerCurrentSignupTokenResponse": {
                "fields": {
                  "status": {
                    "type": "squareup.client.Status",
                    "id": 1,
                    "rule": "optional"
                  },
                  "currentSignupToken": {
                    "type": "squareup.client.onboard.SignupToken",
                    "id": 2,
                    "rule": "optional"
                  },
                  "freeProcessingBalance": {
                    "type": "squareup.client.onboard.FreeProcessingBalance",
                    "id": 3,
                    "rule": "optional"
                  },
                  "mobileCopy": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "mobileHeadline": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE SignupToken @ squareup/client/onboard/referrals.proto at 18:1
 */
export const SignupToken = $root.lookupType('squareup.client.onboard.SignupToken');
fixType(SignupToken, {
  freeProcessingMoney: { required: true },
  freeProcessingDays: { required: true },
  referralUrl: { required: true },
  slug: { required: true },
});
Builder.createAndAttachToType(SignupToken);
/**
 * SOURCE FreeProcessingBalance @ squareup/client/onboard/referrals.proto at 36:1
 */
export const FreeProcessingBalance = $root.lookupType('squareup.client.onboard.FreeProcessingBalance');
fixType(FreeProcessingBalance, {
  freeProcessing: { required: true },
  expiresAt: { required: true },
});
Builder.createAndAttachToType(FreeProcessingBalance);
/**
 * No fields because the referrer token is already in the request
 *
 * SOURCE ReferrerCurrentSignupTokenRequest @ squareup/client/onboard/referrals.proto at 45:1
 */
export const ReferrerCurrentSignupTokenRequest = $root.lookupType('squareup.client.onboard.ReferrerCurrentSignupTokenRequest');
fixType(ReferrerCurrentSignupTokenRequest);
Builder.createAndAttachToType(ReferrerCurrentSignupTokenRequest);
/**
 * SOURCE ReferrerCurrentSignupTokenResponse @ squareup/client/onboard/referrals.proto at 53:1
 */
export const ReferrerCurrentSignupTokenResponse = $root.lookupType('squareup.client.onboard.ReferrerCurrentSignupTokenResponse');
fixType(ReferrerCurrentSignupTokenResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(ReferrerCurrentSignupTokenResponse);
